import Box from '@mui/material/Box';
import Main from 'layouts/Main';
import {
    Application,
    Hero,
    Instagram,
    WelcomeSpeech,
    EventRegistration,
    HomeVideo,
    EventInfo,
    EventTitle,
    EventMaps,
    AbstractSubmission,
    EventHotel,
} from './components';

const Home = () => {
    return (
        <Main>
            <Box display="flex" justifyContent={'center'}>
                <Box width="100vw">
                    <Hero />
                </Box>
            </Box>

            <EventTitle />
            <Application />
            <EventInfo />
            <HomeVideo />
            <WelcomeSpeech />
            <AbstractSubmission />
            <EventRegistration />
            <EventHotel />
            <Instagram />
            <EventMaps />
            {/* <Container
                width='85vw'>
                <QuickAccess />
            </Container> */}
            {/* <Box>
                <Container 
                width='85vw'
                >
                <Workshop />
                </Container>
            </Box> */}

            {/* <Container>
                <AbstractSubmission />
            </Container> */}
            {/* <Box
                sx={{
                background: 'transparent',
                backgroundImage: `linear-gradient(180deg, ${theme.palette.background.paper} 40%, ${theme.palette.primary.main} 5%)`,
                }}
            >
                <Container>
                <Subscription />
                </Container>
            </Box> */}
            {/* <Container
                width='85vw'>
                <PreCongress />
            </Container> */}
        </Main>
    );
};

export default Home;
